import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import { PercentInput, IntegerInput } from "components/Global/FastFormikMaterial";

const StyledPercentInput = styled(PercentInput)`
  & {
    width: 100%;
  }
`;
const StyledIntegerInput = styled(IntegerInput)`
  & {
    width: 100%;
  }
`;
class FlatPercentage extends React.Component {
  componentDidMount() {
    const { percent } = this.props;
    this.setDescription(percent);
  }

  componentDidUpdate(prevProps) {
    const { percent } = this.props;
    const { percent: prevPercent } = prevProps;
    if (percent !== prevPercent) {
      this.setDescription(percent);
    }
  }

  setDescription(percent) {
    if (percent) {
      const description = `${percent}% Penalty`;
      this.props.setDescription(description);
    } else {
      this.props.setDescription("No description");
    }
  }

  render() {
    const { index } = this.props;

    return (
      <Grid item xs={4}>
        <StyledPercentInput
          label="Minimum Prepayment"
          fieldName={`prepaymentSchedules[${index}].percent`}
        />
      </Grid>
    );
  }
}
export default FlatPercentage;
